/**
 * Central registry of z-index values used across the app.
 * Keeping these in one place prevents accidental collisions between
 * stacking layers (e.g. sticky table headers vs. dropdown menus).
 *
 * Usage:
 *   - Inline styles:  style={{ zIndex: ZIndex.selectMenu }}
 *   - Tailwind arb:   className={`z-[${ZIndex.tableHeader}]`}
 */
export const ZIndex = {
  /** Sticky <thead> in TableGrid */
  tableHeader: 10,
  /** react-select dropdown menu — must exceed tableHeader */
  selectMenu: 20,
} as const

export type ZIndexValue = (typeof ZIndex)[keyof typeof ZIndex]
